module.exports = __webpack_public_path__ + "img/bg.723f2835.jpeg";